<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <el-button class="button-teal button__base__admin layout__position-right layout__margin__bottom-30"
                           v-on:click="newOrder()" v-show="false">
                    Create New Order
                </el-button>

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">Bespoke Orders Search</h2>
                    <AdminBespokeSearch v-bind:searchParams="searchParams" v-bind:orders="orders"
                                        v-bind:loading="loading" v-bind:resultsCount="resultsCount"></AdminBespokeSearch>
                </div>

                <div class="layout__width-100 layout__position-left">
                    <el-table :data="orders" style="width: 100%;"
                              class="layout__height-600px layout__scrolling__right layout__margin__bottom-30"
                              v-loading.fullscreen.lock="loading">
                        <!-- v-on:row-click="viewOrders" todo to be added back in when fixed -->
                        <el-table-column prop="code" label="Bespoke ID" width="100">
                        </el-table-column>
                        <el-table-column prop="zdTicket" label="Zendesk ID" width="100">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="140">
                        </el-table-column>
                        <el-table-column prop="created" label="Created" width="200" :formatter="formatDateDDMMYYYYCreated">
                        </el-table-column>
                        <!-- todo this needs to be the assigned to field -->
                        <el-table-column prop="user" label="Assigned To" width="240">
                        </el-table-column>
                        <!-- todo this needs to be the descpatch due date field -->
                        <el-table-column prop="despatchDue" label="Despatch Due" width="240" :formatter="formatDateDDMMYYYYDepatch">
                        </el-table-column>
                        <el-table-column prop="branch" label="Branch" width="100">
                        </el-table-column>
                        <el-table-column prop="name" label="Name" width="300">
                        </el-table-column>
                        <!-- todo this needs to be order no need to know what this is -->
                        <el-table-column prop="orderNo" label="Order No" width="120">
                        </el-table-column>
                        <el-table-column prop="jobName" label="Job Name" width="540" class="text__wordwrap">
                        </el-table-column>
                        <el-table-column prop="billGrossTotal" label="Print Total" width="100"
                                         :formatter="returnFormattedCurrencyGrid">
                        </el-table-column>
                        <!-- todo this needs to be an add total -->
                        <el-table-column prop="" label="Add Total" width="100">
                        </el-table-column>
                    </el-table>
                </div>

                <!--<Pagination v-bind:orders="orders" v-bind:start="start" v-bind:end="end"-->
                            <!--v-bind:pagination="pagination"></Pagination>-->

                <div class="layout__padding-clear layout__width-60">
                    <div class="layout__padding-20-0">
                        <el-pagination class=""
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="this.searchParams.currentPage"
                                       :page-sizes="[20, 40, 60, 80, 100]"
                                       :page-size="this.searchParams.pagination"
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="this.resultsCount">
                        </el-pagination>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import AdminBespokeSearch from '../../components/search/AdminBespokeSearch';
    import {axios} from '@/mixins/Axios.js';
    import {pagination} from '@/mixins/Pagination.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Pagination from "../../components/Pagination.vue";

    export default {
        name: "bespokeOrdersAdmin",
        mixins: [axios, csvDownloadHelper, dataFormatter, pagination],
        components: {
            Pagination,
            AdminBespokeSearch,
        },
        props: {
            view: ''
        },
        data() {
            return {
                resultsCount: '',
                orders: [],
                loading: false,
                searchParams: {
                    orderSource: 'BESPOKE',
                    orderSourceId: null,
                    orderStatus: 'ANY STATUS',
                    orderFreeText: '',
                    assignment: null,
                    territory: null,
                    top: 20,
                    pagination: 20,
                    skip: 0,
                    currentPage: 1,
                    salesDateRange: []
                },
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            viewOrders(bespokeOrder) {
                // console.log(bespokeOrder)
                window.sessionStorage.setItem('_bespokeOrder', JSON.stringify(bespokeOrder));
                this.$router.push({
                    name: '/admin/orders/bespoke/details',
                    params: {
                        bespokeOrder: bespokeOrder
                    },
                    query: {
                        id: bespokeOrder.code,
                    }
                })
            },
            resultsPerPage() {
                document.getElementById('getBespokeOrdersPagination').click()
            },
            csv() {
                document.getElementById('downloadAllResults').click()
            },
            newOrder() {
                this.$router.push({
                    name: '/admin/orders/bespoke/create',
                })
            }
        }
    };
</script>